import script from "./EntryH5.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryH5.vue?vue&type=script&setup=true&lang=js"

import "./EntryH5.vue?vue&type=style&index=0&id=2a53b074&lang=scss"

const __exports__ = script;

export default __exports__